import React from 'react';
import * as JoyIconModule from './re-joy/JoyIcon';
interface JoyAssistantIconProps {
  className?: string;
}
type JoyIconComponent = React.ComponentType<{
  state?: 'listening';
  animated?: boolean;
  size?: 'sm';
  background?: 'cloud';
  className?: string;
}>;

/**
 * Renders the official design-system JoyIcon (listening, animated, sm, cloud).
 * If the design-system bundle fails to resolve, falls back to a static
 * brand-consistent ring mark instead of crashing the page.
 */
export const JoyAssistantIcon: React.FC<JoyAssistantIconProps> = ({
  className
}) => {
  const OfficialJoyIcon = (JoyIconModule as {
    JoyIcon?: JoyIconComponent;
  }).JoyIcon;
  if (OfficialJoyIcon) {
    return <OfficialJoyIcon state="listening" animated={true} size="sm" background="cloud" className={className} data-id="element-139" data-mp="8f5c56i39w2" />;
  }
  return <span aria-hidden="true" className={`inline-flex h-12 w-12 items-center justify-center rounded-full bg-cloud ${className ?? ''}`} data-id="element-140" data-mp="2kz5z4xrcc2br">
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" data-id="element-141" data-mp="39ojkjk39eji5">
        <circle cx="20" cy="20" r="16" stroke="#1F4D4A" strokeWidth="1.5" strokeLinecap="round" strokeDasharray="80 20.5" data-id="element-142" data-mp="35my3dmjozj25" />
        <circle cx="20" cy="20" r="11" stroke="#73697E" strokeWidth="1.5" strokeLinecap="round" strokeDasharray="52 17" data-id="element-143" data-mp="3jn0cokdxp45s" />
        <circle cx="20" cy="20" r="6" stroke="#AECFC1" strokeWidth="1.5" data-id="element-144" data-mp="3elt6gprfwd18" />
        <circle cx="33" cy="11" r="2" fill="#FF6A5C" data-id="element-145" data-mp="3slkr39cgoro7" />
      </svg>
    </span>;
};